import { setError } from "../../domain/error/errorModel";
import { UpdateErrorStore, updateErrorUseCase } from "./updateErrorUseCase";

const setErrorUseCase = (store: UpdateErrorStore) =>
    updateErrorUseCase(store, setError);

export { setErrorUseCase }